<template>
  <el-container v-page-title="teacherInfo.name" v-loading="loading">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item to="/home/teacherList">讲师介绍</el-breadcrumb-item>
      <el-breadcrumb-item :to="`/home/teacherDetail/${this.teacherInfo.teacherId}`">
        {{teacherInfo.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <div slot="header">
        <div style="display: flex">
          <div style="width: 250px">
            <el-image :src="teacherInfo.image" style="width: 225px;height: 320px;"></el-image>
          </div>
          <div style="padding: 0 15px; flex: 1; word-break: break-all">
            <div style="height: 180px">
              <div class="course-tile">
                {{teacherInfo.name}}
              </div>
              <p class="break-all">
                <span class="text-bold">昵称: </span>
                <span class="text">{{teacherInfo.nickname}}</span>
              </p>
              <p class="break-all">
                <span class="text-bold">简介: </span>
                <span class="text" style="max-height: 150px;overflow-y: auto;display: inline-block;flex: 1">{{teacherInfo.intro}}</span>
              </p>
              <p class="break-all">
                <span class="text-bold">座右铭: </span>
                <span class="text">{{teacherInfo.motto}}</span>
              </p>
              <p class="break-all">
                <span class="text-bold">职称: </span>
                <span class="text">{{teacherInfo.position}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <Card title="其他讲师" :cardType="'3'" :itemList="teacherList" :loading="loadingTeacher"></Card>
  </el-container>
</template>

<script>
import {getTeacher, pageListTeacher} from "@/api/teacher";
import Card from '@/views/homePage/Card'
export default {
  name: "TeacherDetail",
  data() {
    return {
      teacherInfo: {},
      loading: true,
      loadingTeacher: false,
      teacherList: [],
    }
  },
  components:{
    Card
  },
  methods: {
    async getTeacherDetail(id) {
      this.loading = true
      let {content} = await getTeacher(id)
      this.teacherInfo = content
      this.loading = false
    },
    async getTeacherList() {
      this.loadingTeacher = true;
      let queryParams = {
        page: 1,
        size: 10,
        name: undefined,
        position: undefined,
      }
      const { content } = await pageListTeacher(queryParams)
      this.teacherList = content.records
      this.loadingTeacher = false
    },
  },
  created() {
    let teacherId = this.$route.params.teacherId
    this.getTeacherDetail(teacherId)
    this.getTeacherList()
  }
}
</script>
<style scoped lang="scss">

.break-all{
  word-break:break-all;
  display: flex;
  line-height: 21px;
  .text {
    margin-left: 10px;
    color: #999999;
    font-size: 14px;
  }
}
.text-bold {
  font-weight: bold;
}
.el-container {
  width: 1200px;
  min-width: 1200px;
  margin: 20px auto 0 ;
}
.box-card {
  margin-top: 20px;
  width: 100%;
  border: 0;
}
.course-tile {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}
.font-price {
  font-size: 25px;
  color: #f01414;
}
.tag-margin-right {
  margin-right: 8px;
}
.study-process {
  position:absolute;
  width: 300px;
  top: 5px;
  right: 10px;
}
</style>